import React, { Component } from "react";
import _ from "lodash";
import { Parallax } from "react-skrollr";
import ProjectMap from "../../containers/ProjectMap";
import PhuketMap from "../../containers/PhuketMap";
import { Slider, Button, Modal, ButtonGroup } from "../../components";
import { multiLanguage } from "../../hoc";
import { assetsPath } from "../../utils";

const Compass = () => {
  return (
    <img
      className="compass"
      src={`${assetsPath()}/images/compass/compass-2x-north.png`}
      alt="compass"
      style={{ position: "absolute", top: "8%", right: "2%", width: 60 }}
    />
  );
};

@multiLanguage()
export default class Destination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // open: true,
      // page: "project",
      open: false,
      page: "country",
    };

    this.projectMapRef = React.createRef();
    this.phuketMapRef = React.createRef();
  }
  handleCloseModal = () => {
    // reset
    if (this.projectMapRef && this.projectMapRef.current)
      this.projectMapRef.current.reset();
    if (this.phuketMapRef && this.phuketMapRef.current)
      this.phuketMapRef.current.reset();

    // close
    this.setState({
      open: false,
    });
  };
  handleClickButtonMenu = (key) => {
    console.log("handleClickButtonMenu", key);
    this.setState({
      open: true,
      page: key,
    });
  };
  renderCountryMap = (imageMap) => {
    return (
      <div className="page-map">
        <div
          className="page-map-background"
          style={{ backgroundImage: `url(${imageMap})` }}
        />
        <Compass />
      </div>
    );
  };
  renderCityMap = (imageMap) => {
    const { t, currentLanguage } = this.props;
    return (
      <React.Fragment>
        <PhuketMap
          t={t}
          currentLanguage={currentLanguage}
          isMobile={this.props.isMobile}
          ref={this.phuketMapRef}
        />
        <Compass />
      </React.Fragment>
    );
  };
  renderProjectMap = (imageMap) => {
    const { t, currentLanguage, project } = this.props;
    return (
      <React.Fragment>
        <ProjectMap
          t={t}
          currentLanguage={currentLanguage}
          ref={this.projectMapRef}
          project={project}
        />
        <Compass />
      </React.Fragment>
    );
  };
  render() {
    const { open, page } = this.state;
    const {
      t,
      currentLanguage,
      imageSlider,
      title,
      description,
      mapData,
    } = this.props;
    const findKey = _.find(mapData, ["value", page]);
    const keyValue = _.get(findKey, "value");
    console.log("render-destination", page);
    let imageMap;
    if (keyValue === "country") {
      imageMap = _.get(findKey, `image.${currentLanguage}`);
    }
    if (keyValue === "city" || keyValue === "project") {
      imageMap = _.get(findKey, "images");
    }
    return (
      <div className="section-destination">
        <div className="parallax-container">
          <Parallax
            data={{
              "data-bottom-top": "transform: translateY(0);",
              "data-top-bottom": "transform: translateY(0);",
            }}
          >
            <div className="container-slider">
              <Slider
                type="type-background"
                sliderRef={this.sliderRef}
                items={imageSlider}
                settings={{ arrows: false }}
                uiRenderer={(item, index) => {
                  return (
                    <div
                      className="img-background"
                      style={{
                        backgroundImage: `url(${item.image})`,
                        backgroundPosition: item.backgroundPosition,
                      }}
                    />
                  );
                }}
              />
            </div>
          </Parallax>
        </div>
        <div className="container-destination-content">
          <div className="destination-content">
            <h2>{t(title)}</h2>
            <div dangerouslySetInnerHTML={{ __html: t(description) }} />
            <div className="destination-button">
              {_.map(mapData, (item, index) => {
                return (
                  <Button
                    key={index}
                    type="primary"
                    hoverStyle={{ backgroundColor: "white", color: "#04a8a6" }}
                    defaultStyle={{
                      marginRight: "5px",
                      marginBottom: "7px",
                      padding: "2px 11px",
                    }}
                    onClick={() => this.handleClickButtonMenu(item.value)}
                  >
                    {t(item.name)}
                  </Button>
                );
              })}
            </div>
          </div>
        </div>
        <div className="destination-modal-content">
          {open && (
            <Modal name="destination-modal" onCancel={this.handleCloseModal}>
              {page === "country" && this.renderCountryMap(imageMap)}
              {page === "city" && this.renderCityMap(imageMap)}
              {page === "project" && this.renderProjectMap(imageMap)}
              <div className="destination-button-group">
                <ButtonGroup
                  value={page}
                  items={mapData}
                  onChange={(value) => this.setState({ page: value })}
                  direction="horizontal"
                  renderItem={({ value, name, active, onClick }) => {
                    return (
                      <Button
                        key={value}
                        type="secondary"
                        active={active}
                        activeStyle={{ backgroundColor: "#00a9a5" }}
                        hoverStyle={{ backgroundColor: "#00a9a5" }}
                        defaultStyle={{
                          padding: "12px 17px",
                          marginRight: "2px",
                          fontWeight: "bold",
                          fontSize: "13px",
                          letterSpacing: "1px",
                        }}
                        onClick={onClick}
                      >
                        {t(name)}
                      </Button>
                    );
                  }}
                />
              </div>
            </Modal>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/Destination.js